import { ApolloQueryResult, OperationVariables } from "@apollo/client";
import { Paper, Typography } from "@lyfegen-platform/react-common";
import { Divider } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { THREAD_SUBSCRIPTION } from "./queries";
import useMessagesStyles from "./use-messages-styles";
import { GetMessagesQuery } from "./types/queries.generated";
import SubscriptionForUpdates from "../../../hooks/subscription-for-updates";

interface CaseMessagesPlaceholderProps {
	handleRefetch: (variables?: Partial<OperationVariables> | undefined) => Promise<ApolloQueryResult<GetMessagesQuery>>;
	scrollToBottom?: () => null;
	isSettled: boolean;
}

const CaseMessagesPlaceholder: React.FC<CaseMessagesPlaceholderProps> = ({ isSettled, handleRefetch, scrollToBottom }) => {
	const { messagesPaper } = useMessagesStyles();
	const { t } = useTranslation();

	const onCompleted = () => {
		handleRefetch();
		scrollToBottom && scrollToBottom();
	};

	return (
		<>
			<Paper classes={{ root: messagesPaper }} style={{ minHeight: "300px" }}>
				<Typography color="textSecondary">{t(isSettled ? "no-chat-messages" : "this-is-the-beginning")}</Typography>
				<Divider />
			</Paper>
			<SubscriptionForUpdates onCompleted={onCompleted} query={THREAD_SUBSCRIPTION} />
		</>
	);
};

export default CaseMessagesPlaceholder;
